import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "./index.scss";
import { clearAuthData } from "../../helpers";
import { useAuth } from "../../contexts/AuthProvider";

export default function AuthModal() {
    const history = useHistory();
    const { authModal, setAuthModal } = useAuth();

    const handleClose = () => {
        setAuthModal(false);
        clearAuthData();
        history.push("/signin");
    };

    useEffect(() => { }, [authModal]);

    return (
        <Modal
            show={authModal}
            onHide={handleClose}
            keyboard={false}
            size="sm"
            centered
            className="auth-modal-style"
        >
            <Modal.Body className="text-center p-4">
                <p className="text-danger mt-2">{"You are not authorized. Please log in to continue."}</p>
                <button className="btn btn-secondary-color btn-border-color mt-3" onClick={handleClose}>
                    Ok
                </button>
            </Modal.Body>
        </Modal>
    );
}
